import { render } from "./user-info-third-party-devices.vue?vue&type=template&id=33a1b9b9&scoped=true&ts=true"
import script from "./user-info-third-party-devices.vue?vue&type=script&lang=ts"
export * from "./user-info-third-party-devices.vue?vue&type=script&lang=ts"

import "./user-info-third-party-devices.vue?vue&type=style&index=0&id=33a1b9b9&scoped=true&lang=css"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a1b9b9"]])

export default __exports__